<template>
  <div class="__popup-content">
    <div class="content">
      <div class="left-side">
        <QuickRangeSelector
          :range="currentRange"
          :options="quickRangeOptions"
          :max-date="maxDate"
          @change="changeRange"
        />
      </div>
      <div class="right-side">
        <RangeInput
          :range="currentRange"
          :min-date="minDate"
          :max-date="maxDate"
          :granularity="granularity"
          @change="changeRange"
        />
        <DatePicker
          :range="currentRange"
          :min-date="minDate"
          :max-date="maxDate"
          :range-limit-start="rangeLimitStart"
          :range-limit-end="rangeLimitEnd"
          :range-limit-unit="rangeLimitUnit"
          @change="changeRange"
        />
      </div>
    </div>
    <Footer @submit="handleSubmit" />
  </div>
</template>

<script>
import RangeInput from './RangeInput';
import DatePicker from './DatePicker';
import QuickRangeSelector from './QuickRangeSelector';
import Footer from './Footer';

export default {
  name: 'Controller',
  components: { RangeInput, DatePicker, QuickRangeSelector, Footer },
  props: {
    range: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    quickRangeOptions: {
      type: Array,
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    granularity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentRange: {},
    };
  },
  mounted() {
    this.currentRange = this.range;
  },
  computed: {
    rangeLimitStart() {
      if (this.granularity === 'daily') {
        return 2;
      } else return undefined;
    },
    rangeLimitEnd() {
      if (this.granularity === 'daily') {
        return 2;
      } else return undefined;
    },
    rangeLimitUnit() {
      return 'month';
    },
  },
  methods: {
    changeRange(range) {
      this.currentRange = range;
    },
    handleSubmit() {
      this.$emit('submit', this.currentRange);
    },
  },
};
</script>

<style lang="scss" scoped>
.__popup-content {
  .content {
    display: flex;
    padding: $padding-sm;
  }
}
</style>
